/**

 * Anti-Bot Protection System

 * Layer 1: Honeypot hidden field trap

 * Layer 2: Time-based detection (< 2s = bot)

 * Layer 3: Behavioral analysis (mouse/touch/keyboard)

 * Layer 4: Headless browser detection

 */

(function () {

    'use strict';



    var MIN_SUBMIT_TIME_MS = 2000;

    var humanSignals = { mouse: false, keyboard: false, touch: false, scroll: false };

    var interactionCount = 0;



    function trackHumanSignals() {

        function onMouse() {

            humanSignals.mouse = true;

            interactionCount++;

        }

        function onKey() {

            humanSignals.keyboard = true;

            interactionCount++;

        }

        function onTouch() {

            humanSignals.touch = true;

            interactionCount++;

        }

        function onScroll() {

            humanSignals.scroll = true;

            interactionCount++;

        }



        document.addEventListener('mousemove', onMouse, { once: true, passive: true });

        document.addEventListener('keydown', onKey, { once: true, passive: true });

        document.addEventListener('touchstart', onTouch, { once: true, passive: true });

        document.addEventListener('scroll', onScroll, { once: true, passive: true });

    }



    function isHeadlessBrowser() {

        var dominated = false;



        if (navigator.webdriver === true) dominated = true;



        if (/HeadlessChrome|PhantomJS|Puppeteer|Selenium|Playwright/i.test(navigator.userAgent)) {

            dominated = true;

        }



        if (typeof window.callPhantom === 'function' || typeof window._phantom !== 'undefined') {

            dominated = true;

        }



        if (typeof window.__nightmare === 'object') dominated = true;



        if (navigator.languages && navigator.languages.length === 0) dominated = true;



        if (!window.chrome && /Chrome/.test(navigator.userAgent)) dominated = true;



        return dominated;

    }



    function hasHumanBehavior() {

        return humanSignals.mouse || humanSignals.keyboard || humanSignals.touch || humanSignals.scroll;

    }



    function initHoneypot() {

        var timestampFields = document.querySelectorAll('.hp-timestamp');

        var now = Date.now().toString();

        timestampFields.forEach(function (field) {

            field.value = now;

        });



        trackHumanSignals();



        var forms = document.querySelectorAll('form');

        forms.forEach(function (form) {

            var hpField = form.querySelector('.hp-field');

            if (!hpField) return;



            form.addEventListener('submit', function (e) {

                // Layer 1: Honeypot field filled = bot

                if (hpField.value.trim() !== '') {

                    e.preventDefault();

                    e.stopImmediatePropagation();

                    return false;

                }



                // Layer 2: Too fast submission = bot

                var ts = form.querySelector('.hp-timestamp');

                if (ts && ts.value) {

                    var elapsed = Date.now() - parseInt(ts.value, 10);

                    if (elapsed < MIN_SUBMIT_TIME_MS) {

                        e.preventDefault();

                        e.stopImmediatePropagation();

                        return false;

                    }

                }



                // Layer 3: No human interaction detected = bot

                if (!hasHumanBehavior() && interactionCount === 0) {

                    e.preventDefault();

                    e.stopImmediatePropagation();

                    return false;

                }



                // Layer 4: Headless browser detected = bot

                if (isHeadlessBrowser()) {

                    e.preventDefault();

                    e.stopImmediatePropagation();

                    return false;

                }

            });

        });

    }



    if (document.readyState === 'loading') {

        document.addEventListener('DOMContentLoaded', initHoneypot);

    } else {

        initHoneypot();

    }

})();

